import { SERVER_URL } from "../../constants";
import { fetchGetAuth } from "../../util/FetchUtil";

const controller = "pix-transacao/";

export const findPixTransacaoByCurrentInstituicao = (page) => {
  const url = SERVER_URL + controller + "query-page?page=" + page;
  return fetchGetAuth(url);
};
